// src/components/Dashboard/MenuButton.jsx
import React from "react";

const MenuButton = ({ icon: Icon, text, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={`w-full flex items-center space-x-2 p-2 rounded-lg hover:bg-red-50 text-gray-700 hover:text-red-600 ${
      isActive ? "bg-red-50 text-red-600" : ""
    }`}
  >
    <Icon className="w-5 h-5" />
    <span className="text-sm">{text}</span>
  </button>
);

export default MenuButton;
